import { Search } from "lucide-react";

import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

export type StockFilterTab =
  | "all"
  | "purchased"
  | "ingredient"
  | "direct"
  | "product";

interface Props {
  query: string;
  onQueryChange: (query: string) => void;
  typeFilter: string;
  onTypeFilterChange: (type: StockFilterTab) => void;
  statusFilter: string;
  onStatusFilterChange: (status: string) => void;
}

const TYPE_TABS: { value: StockFilterTab; label: string }[] = [
  { value: "all", label: "Semua" },
  { value: "purchased", label: "Barang Beli" },
  { value: "ingredient", label: "Bahan Resep" },
  { value: "direct", label: "Langsung Pakai" },
  { value: "product", label: "Produk Siap Jual" },
];

/** Type tabs (top-right of the card header). */
export function StockTypeTabs({
  typeFilter,
  onTypeFilterChange,
}: Pick<Props, "typeFilter" | "onTypeFilterChange">) {
  return (
    <div className="flex items-center rounded-lg border bg-muted/30 p-1 w-full sm:w-auto overflow-x-auto">
      {TYPE_TABS.map((tab) => (
        <Button
          key={tab.value}
          type="button"
          variant={typeFilter === tab.value ? "secondary" : "ghost"}
          size="sm"
          onClick={() => onTypeFilterChange(tab.value)}
          className="h-8 sm:h-7 flex-1 sm:flex-initial text-xs font-medium"
        >
          {tab.label}
        </Button>
      ))}
    </div>
  );
}

/** Search box and status filter. */
export function StockSearchFilters({
  query,
  onQueryChange,
  statusFilter,
  onStatusFilterChange,
}: Pick<
  Props,
  "query" | "onQueryChange" | "statusFilter" | "onStatusFilterChange"
>) {
  return (
    <div className="mt-2 flex flex-wrap items-center gap-2 pt-2 border-t">
      <div className="relative w-full sm:w-auto sm:flex-1 sm:max-w-sm">
        <Search className="absolute left-2.5 top-2.5 h-4 w-4 text-muted-foreground" />
        <Input
          value={query}
          onChange={(e) => onQueryChange(e.target.value)}
          placeholder="Cari nama barang / SKU / kategori..."
          className="h-9 pl-8 text-xs"
        />
      </div>

      <Select value={statusFilter} onValueChange={onStatusFilterChange}>
        <SelectTrigger className="h-9 w-full sm:w-[150px] text-xs">
          <SelectValue placeholder="Status Stok" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">Semua Status</SelectItem>
          <SelectItem value="in_stock">Stok Aman</SelectItem>
          <SelectItem value="low_stock">Stok Menipis</SelectItem>
          <SelectItem value="out_of_stock">Stok Habis</SelectItem>
        </SelectContent>
      </Select>

      {statusFilter !== "all" && (
        <Button
          type="button"
          variant="ghost"
          size="sm"
          onClick={() => onStatusFilterChange("all")}
          className="h-9 text-xs text-muted-foreground hover:text-foreground w-full sm:w-auto"
        >
          Reset Filter
        </Button>
      )}
    </div>
  );
}
